import { ApiTypes } from "api";

const alarmState = {
    data: new Array<ApiTypes.AlarmDto>() ,
}

export default alarmState;